// extracted by mini-css-extract-plugin
export default {"faq":"privacy_faq__LuNMt","faq1":"privacy_faq1__PQRDV"};